type BlogPostImageProps = {
  icon?: string
}

export default function BlogPostImage({ icon: _icon }: BlogPostImageProps) {
  return (
    <div className="my-3 flex aspect-video h-auto w-full items-center justify-center rounded-2xl bg-primary-950"></div>
  )
}
